/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Permission_TitleInputs */



/**
* | output |
* | --- |
* | "You do not have permission to manage your team." |
*
* @param {Team_Manager_No_Permission_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_permission_title = /** @type {((inputs?: Team_Manager_No_Permission_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Permission_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n’avez pas l’autorisation de gérer votre équipe.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben keine Berechtigung, Ihr Team zu verwalten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non hai l'autorizzazione per gestire il tuo team.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("У вас нет разрешения на управление своей командой.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No tienes permiso para administrar tu equipo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您没有管理团队的权限。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームを管理する権限がありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपको अपनी टीम का प्रबंधन करने की अनुमति नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você não tem permissão para gerenciar sua equipe.")
	return /** @type {LocalizedString} */ ("You do not have permission to manage your team.")
});